<template>
    <v-content class="pa-12">
        <v-layout style="background-color: #FAF5F2;">
            <v-flex>
                <v-layout mb-4>
                    <v-flex style="font-size: 28px;font-weight: bold;color: #737373">
                        <span>แบบฟอร์ม</span>
                    </v-flex>
                </v-layout>

                <v-layout>
                    <v-flex>
                        <v-layout pa-6 mt-3 style="background-color: #3E7662;">
                            <v-flex d-flex justify-start align-center style="font-size: 28px;color: white">
                                <div style="font-weight: bold" @click="setData">หนังสือรับรอง COA</div>
                            </v-flex>
                            <v-flex d-flex justify-end align-center style="font-weight: bold;font-size: 13px;color: white">
                                <span>RL 01_2560</span>
                            </v-flex>
                        </v-layout>

                    <!-- Start Form -->

                        <!-- Start Card 1 -->
                        <v-card style="padding: 50px 100px 100px 100px">
                            <!-- Logo -->
                            <v-layout>
                                <v-flex>
                                    <img src="../../assets/LogoEN.png" width="124" alt="">
                                </v-flex>
                            </v-layout>

                            <!-- Header -->
                            <v-layout mt-4>
                                <v-flex>
                                    <div style="font-weight: bold;font-size: 20px;">The Institutional Review Board, Royal Thai Army Medical Department</div>
                                    <div style="font-weight: normal;font-size: 20px;">317/5 Rajavithi Road, Rajathevee, Bangkok 10400, Thailand</div>
                                </v-flex>
                            </v-layout>

                            <!-- divider -->
                            <v-layout mt-8>
                                <v-flex>
                                    <v-divider style="background-color: #544A44;"></v-divider>
                                </v-flex>
                            </v-layout>

                            <!-- No. IRBRTA and Code -->
                            <v-layout mt-8>
                                <v-flex xs4 d-flex align-center>
                                    <!-- No. IRBRTA -->
                                    <v-layout>
                                        <v-flex shrink pt-5 style="font-weight: bold;">
                                            <span>No. IRBRTA</span>
                                        </v-flex>
                                        <v-flex xs4 class="text-field-center">
                                            <v-text-field v-model="form.IRBTABefore" hide-details />
                                        </v-flex>
                                        <span class="pt-5" style="font-weight: bold;">/</span>
                                        <v-flex xs4 class="text-field-center">
                                            <v-text-field v-model="form.IRBTAAfter" hide-details />
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-spacer></v-spacer>
                                <v-flex xs4 d-flex align-center>
                                    <!-- Code -->
                                    <v-layout>
                                        <v-flex class="text-end" mr-4 pt-2 style="font-weight: bold;">
                                            <span>Code :</span>
                                        </v-flex>
                                        <v-flex>
                                            <v-text-field
                                                    v-model="form.enCode"
                                                    placeholder="รหัส protocol"
                                                    outlined
                                                    dense
                                                    color="#3E7662"
                                                    background-color="#FBF6F3"
                                                    hide-details
                                            />
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <!-- Form Group -->
                            <v-layout py-12 mt-12>
                                <v-flex>
                                    <v-layout justify-center>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>Title of Project</span>
                                        </v-flex>
                                        <v-flex xs6>
                                            <textfield-form
                                                    :model="form.enTitle"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('enTitle', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout justify-center>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>Protocol No.</span>
                                        </v-flex>
                                        <v-flex xs6>
                                            <textfield-form
                                                    :model="form.enProtocol"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('enProtocol', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout justify-center>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>Principal Investigator</span>
                                        </v-flex>
                                        <v-flex xs6>
                                            <textfield-form
                                                    :model="form.enPrincipal"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('enPrincipal', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout justify-center>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>Name of Department</span>
                                        </v-flex>
                                        <v-flex xs6>
                                            <textfield-form
                                                    :model="form.enDepartment"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('enDepartment', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout justify-center>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>Study Site</span>
                                        </v-flex>
                                        <v-flex xs6>
                                            <textfield-form
                                                    :model="form.enStudySite"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('enStudySite', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <!-- Table -->
                            <v-layout>
                                <v-flex class="table-style">
                                    <table class="table-fill">
                                        <thead>
                                            <tr>
                                                <th width="35%" class="text-center">Approval documents</th>
                                                <th width="65%" class="text-center">Reference (e.g. version and date)</th>
                                            </tr>
                                        </thead>
                                        <tbody class="table-hover">
                                            <tr>
                                                <td class="text-left">Research protocol</td>
                                                <td class="text-left">
                                                    <v-text-field v-model="form.researchProtocol" color="#3E7662" outlined dense hide-details/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-left">Informed consent documents</td>
                                                <td class="text-left">
                                                    <v-text-field v-model="form.informedConsent" color="#3E7662" outlined dense hide-details/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-left">Others</td>
                                                <td class="text-left">
                                                    <v-text-field v-model="form.other" color="#3E7662" outlined dense hide-details/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-left">Principal investigator (s)</td>
                                                <td class="text-left">
                                                    <v-text-field v-model="form.investigator" color="#3E7662" outlined dense hide-details/>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </v-flex>
                            </v-layout>

                            <!-- Tag paragraph -->
                            <v-layout mt-12 style="padding-left: 80px; padding-right: 80px;">
                                <v-flex class="text-start">
                                    <p style="text-indent: 10rem">
                                        The aforementioned documents have been reviewed and
                                        approved by the Institutional Review Board, Royal Thai Army
                                        Medical Department in compliance with international
                                        guidelines such as Declaration of Helsinki, the Belmont
                                        Report, CIOMS Guidelines and the International Conference
                                        on Hermonisation of Technical Requirements for Registration
                                        of Pharmaceuticals for Human Use - Good Clinical Practice (ICH - GCP)
                                    </p>
                                </v-flex>
                            </v-layout>

                            <!-- Form Date -->
                            <v-layout mt-12 style="padding-left: 80px; padding-right: 80px;">
                                <v-flex xs3 d-flex align-center class="text-start" style="font-weight: bold">
                                   <span>Date of Approval</span>
                                </v-flex>
                                <v-flex shrink mr-3 d-flex align-center class="text-end" style="font-weight: bold">
                                   <span>วันที่</span>
                                </v-flex>
                                <v-flex xs5 d-flex align-center class="text-start">
                                    <v-menu
                                            v-model="menu_date0"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    v-model="dateChange0"
                                                    readonly
                                                    hide-details
                                                    append-icon="date_range"
                                                    background-color="#FBF6F3"
                                                    item-color="#3E7662"
                                                    color="#3E7662"
                                                    filled
                                                    outlined
                                                    dense
                                                    v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                                @input="selectDate($event, 'menu_date0')"
                                                locale="th"
                                                type="date"
                                                color="#3E7662"
                                                header-color="#3E7662"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </v-layout>
                            <v-layout mt-12 style="padding-left: 80px; padding-right: 80px;">
                                <v-flex xs3 d-flex align-center class="text-start" style="font-weight: bold">
                                   <span>Date of Expiration</span>
                                </v-flex>
                                <v-flex shrink mr-3 d-flex align-center class="text-end" style="font-weight: bold">
                                    <span>วันที่</span>
                                </v-flex>
                                <v-flex xs5 d-flex align-center class="text-start">
<!--                                   <DateInputForm-->
<!--                                           :model="form.enExpireDate"-->
<!--                                           label="วันที่"-->
<!--                                           hide-detail-->
<!--                                   />-->
                                    <v-menu
                                            v-model="menu_date6"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    v-model="dateChange6"
                                                    readonly
                                                    hide-details
                                                    append-icon="date_range"
                                                    background-color="#FBF6F3"
                                                    item-color="#3E7662"
                                                    color="#3E7662"
                                                    filled
                                                    outlined
                                                    dense
                                                    v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                                @input="selectDate($event, 'menu_date6')"
                                                locale="th"
                                                type="date"
                                                color="#3E7662"
                                                header-color="#3E7662"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </v-layout>

                            <!--frequency-->
                            <v-layout mt-12 style="padding-left: 80px; padding-right: 80px;">
                                <v-flex pt-4 shrink d-flex align-center class="text-start" style="font-weight: bold">
                                   <span>Frequency of progress report submission</span>
                                </v-flex>
                                <v-flex xs4 d-flex align-center class="text-start" style="padding-left: 15px;">
                                   <v-text-field
                                           color="#3E7662"
                                           hide-details
                                           v-model="form.enFrequency"
                                   />
                                </v-flex>
                                <v-flex pt-4 shrink style="font-weight: bold">
                                    <span>(6 months or 1 year)</span>
                                </v-flex>
                            </v-layout>

                            <!--signature-->
                            <v-layout style="padding-left: 80px; padding-right: 80px;margin-top: 100px">
                                <v-flex xs4 d-flex align-center class="text-start">
                                   <v-text-field
                                           v-model="form.enSignature"
                                           color="#3E7662"
                                           append-icon="edit"
                                   />
                                </v-flex>
                            </v-layout>

                            <v-layout style="padding-left: 80px; padding-right: 80px;">
                                <v-flex class="text-start" style="font-weight: bold">
                                    <div>Colonel Suthee Panichkul, M.D.</div>
                                    <div>Chairperson, Institutional Review Board,</div>
                                    <div>Royal Thai Army Medical Department</div>
                                </v-flex>
                            </v-layout>

                            <v-layout style="padding-left: 80px; padding-right: 80px;margin-top: 150px">
                                <v-flex class="text-start" style="font-weight: bold">
                                    <div>
                                        For all documents approved the Institutional Review Board, Royal Thai Army
                                        Medical Department (IRB RTA), investigators must comply with the followings:
                                    </div>
                                    <div style="margin-top: 30px">
                                        1. Conduct the research in accordance with the approved protocol and the
                                        principles of research ethics as set forth in the Belmont Report.
                                    </div>
                                    <div style="margin-top: 30px">
                                        2. Unless consent has been waived, conduct the informed consent process
                                        without coercion or undue influence, and provide the potential subject
                                        sufficient opportunity to consider whether or not to participate.
                                    </div>
                                        <div>- Use only the most current consent form bearing the IRB RTA “APPROVED” stamp </div>
                                        <div>- Use only recruitment documents / materials approved by the IRB RTA</div>
                                    <div style="margin-top: 30px">
                                        3. IRB RTA approval is required before implementing any changes in the
                                        research protocol, information sheet and research-related documents unless
                                        those changes are required urgently for the safety of the research subjects.
                                    </div>
                                    <div style="margin-top: 30px">
                                        4. Promptly report to the IRB RTA all unanticipated problems
                                        (adverse events, protocol deviations and violations and other problems)
                                        that meet all of the following criteria:
                                    </div>
                                        <div>- Unexpected (in terms of nature, severity or frequency);</div>
                                        <div>- Related or possibly related to participation in the research; and </div>
                                        <div>- Suggests that the research places subjects or others at a greater risk of harm than was previously known or recognized. </div>
                                    <div style="margin-top: 30px">
                                        5. Any new information that may affect the risk and benefit of the research
                                        subjects must be promptly reported to the IRB RTA.
                                    </div>
                                    <div style="margin-top: 30px">
                                        6. Summit to the IRB RTA a progress report (with currently used informed
                                        consent documents) for continuing review and for renewing the approval at
                                        least 30 days before expiration date. For failure to provide a progress
                                        report for continuing review to the IRB RTA, all research activities involving
                                        research subjects must stop. Enrollment of new subjects cannot occur after
                                        the expiration of the IRB RTA approval.
                                    </div>
                                </v-flex>
                            </v-layout>

                            <v-layout mt-12 pa-12 style="border: 1px solid #000000; border-radius: 5px; font-weight: bold;">
                                <v-flex>
                                    <div>
                                        Please go to http://www.irbrta.pmk.ac.thto download IRB RTA forms for reporting.
                                    </div>
                                    <div>
                                        Any questions, please contact the IRB RTA staff at (662) 763-4297, (662) 763-4270
                                    </div>
                                    <div style="margin-top: 30px">
                                        E-mail:irbrta@yahoo.com, irbrta@amed.go.th
                                    </div>
                                </v-flex>
                            </v-layout>

                            <v-layout mt-12>
                                <v-flex class="text-start">
                                    <span>สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span>
                                </v-flex>
                            </v-layout>

                        </v-card>
                        <!--End Card 1 -->

                        <!-- Start Card 2 -->
                        <v-card class="mt-12" style="padding: 50px 100px 100px 100px">
                            <!-- Logo -->
                            <v-layout>
                                <v-flex>
                                    <img src="../../assets/LogoTh.png" width="124" alt="">
                                </v-flex>
                            </v-layout>

                            <!-- Header -->
                            <v-layout mt-4>
                                <v-flex>
                                    <div style="font-weight: bold;font-size: 20px;">คณะอนุกรรมการพิจารณาโครงการวิจัย กรมแพทย์ทหารบก</div>
                                    <div style="font-weight: normal;font-size: 20px;">317/5ถนนราชวิถีเขต ราชเทวีกรุงเทพฯ 10400</div>
                                </v-flex>
                            </v-layout>

                            <!-- divider -->
                            <v-layout mt-8>
                                <v-flex>
                                    <v-divider style="background-color: #544A44;"></v-divider>
                                </v-flex>
                            </v-layout>

                            <!-- No. IRBRTA and Code -->
                            <v-layout mt-8>
                                <v-flex xs4 d-flex align-center>
                                    <!-- No. IRBRTA -->
                                    <v-layout>
                                        <v-flex shrink pt-5 style="font-weight: bold;">
                                            <span>ที่ IRBRTA</span>
                                        </v-flex>
                                        <v-flex xs4 class="text-field-center">
                                            <v-text-field color="#3E7662" v-model="form.thIRBTABefore" hide-details />
                                        </v-flex>
                                        <span class="pt-5" style="font-weight: bold;">/</span>
                                        <v-flex xs4 class="text-field-center">
                                            <v-text-field color="#3E7662" v-model="form.thIRBTAAfter" hide-details />
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-spacer></v-spacer>
                                <v-flex xs4 d-flex align-center>
                                    <!-- Code -->
                                    <v-layout>
                                        <v-flex class="text-end" mr-4 pt-2 style="font-weight: bold;">
                                            <span>รหัสโครงการ :</span>
                                        </v-flex>
                                        <v-flex>
                                            <v-text-field
                                                    v-model="form.thCode"
                                                    placeholder="EC"
                                                    outlined
                                                    dense
                                                    color="#3E7662"
                                                    background-color="#FBF6F3"
                                                    hide-details
                                            />
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <!-- Form Group -->
                            <v-layout py-12 mt-12>
                                <v-flex>
                                    <v-layout justify-center>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>ชื่อโครงการวิจัย</span>
                                        </v-flex>
                                        <v-flex xs6>
                                            <textarea-form
                                                    :model="form.thTitle"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('thTitle', $event)"
                                            ></textarea-form>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout justify-center>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>เลขที่โครงการวิจัย</span>
                                        </v-flex>
                                        <v-flex xs6>
                                            <textfield-form
                                                    :model="form.thProtocol"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('thProtocol', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout justify-center>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>ชื่อผู้วิจัยหลัก</span>
                                        </v-flex>
                                        <v-flex xs6>
                                            <textfield-form
                                                    :model="form.thPrincipal"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('thPrincipal', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout justify-center>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>สังกัดหน่วยงาน</span>
                                        </v-flex>
                                        <v-flex xs6>
                                            <textfield-form
                                                    :model="form.thDepartment"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('thDepartment', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout justify-center>
                                        <v-flex xs2 mr-4 pt-2 style="text-align: right;font-weight: bold;">
                                            <span>สถานที่ทําการวิจัย</span>
                                        </v-flex>
                                        <v-flex xs6>
                                            <textfield-form
                                                    :model="form.thStudySite"
                                                    style="font-weight: bold"
                                                    @update-data="updateData('thStudySite', $event)"
                                            ></textfield-form>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <!-- เอกสารรับรอง -->
                            <v-layout>
                                <v-flex>
                                    <v-layout>
                                        <v-flex class="text-start">
                                            <span style="font-weight: bold;font-size: 18px;">เอกสารรับรอง</span>
                                        </v-flex>
                                    </v-layout>
                                    <!-- เอกสารรับรอง row 1 -->
                                    <v-layout pl- style="font-weight: bold;">
                                        <v-flex shrink pt-5>
                                            <span>1.)</span>
                                        </v-flex>
                                        <v-flex xs6 px-2>
                                            <v-text-field
                                                    color="#3E7662"
                                                    v-model="form.approveDoc1"
                                            />
                                        </v-flex>
                                        <v-flex shrink pt-5>
                                            <span>ฉบับที่</span>
                                        </v-flex>
                                        <v-flex xs2 px-2>
                                            <v-text-field
                                                    color="#3E7662"
                                                    v-model="form.approveDoc1Version"
                                            />
                                        </v-flex>
                                        <v-flex shrink pt-5>
                                            <span>วันที่</span>
                                        </v-flex>
                                        <v-flex mt-4 xs2 px-2>
                                            <v-menu
                                                    v-model="menu_date1"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                            v-model="dateChange1"
                                                            readonly
                                                            item-color="#3E7662"
                                                            color="#3E7662"
                                                            dense
                                                            v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                        @input="selectDate($event, 'menu_date1')"
                                                        locale="th"
                                                        type="date"
                                                        color="#3E7662"
                                                        header-color="#3E7662"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                    <!-- เอกสารรับรอง row 2 -->
                                    <v-layout pl- style="font-weight: bold;">
                                        <v-flex shrink pt-5>
                                            <span>2.)</span>
                                        </v-flex>
                                        <v-flex xs6 px-2>
                                            <v-text-field
                                                    color="#3E7662"
                                                    v-model="form.approveDoc2"
                                            />
                                        </v-flex>
                                        <v-flex shrink pt-5>
                                            <span>ฉบับที่</span>
                                        </v-flex>
                                        <v-flex xs2 px-2>
                                            <v-text-field
                                                    color="#3E7662"
                                                    v-model="form.approveDoc2Version"
                                            />
                                        </v-flex>
                                        <v-flex shrink pt-5>
                                            <span>วันที่</span>
                                        </v-flex>
                                        <v-flex mt-4 xs2 px-2>
                                            <v-menu
                                                    v-model="menu_date2"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                            v-model="dateChange2"
                                                            readonly
                                                            item-color="#3E7662"
                                                            color="#3E7662"
                                                            dense
                                                            v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                        @input="selectDate($event, 'menu_date2')"
                                                        locale="th"
                                                        type="date"
                                                        color="#3E7662"
                                                        header-color="#3E7662"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                    <!-- เอกสารรับรอง row 2 -->
                                    <v-layout pl- style="font-weight: bold;">
                                        <v-flex shrink pt-5>
                                            <span>3.)</span>
                                        </v-flex>
                                        <v-flex xs6 px-2>
                                            <v-text-field
                                                    color="#3E7662"
                                                    v-model="form.approveDoc3"
                                            />
                                        </v-flex>
                                        <v-flex shrink pt-5>
                                            <span>ฉบับที่</span>
                                        </v-flex>
                                        <v-flex xs2 px-2>
                                            <v-text-field
                                                    color="#3E7662"
                                                    v-model="form.approveDoc3Version"
                                            />
                                        </v-flex>
                                        <v-flex shrink pt-5>
                                            <span>วันที่</span>
                                        </v-flex>
                                        <v-flex mt-4 xs2 px-2>
                                            <v-menu
                                                    v-model="menu_date3"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                            v-model="dateChange3"
                                                            readonly
                                                            item-color="#3E7662"
                                                            color="#3E7662"
                                                            dense
                                                            v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                        @input="selectDate($event, 'menu_date3')"
                                                        locale="th"
                                                        type="date"
                                                        color="#3E7662"
                                                        header-color="#3E7662"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <!-- Tag paragraph -->
                            <v-layout mt-12 style="padding-left: 80px; padding-right: 80px;">
                                <v-flex class="text-start">
                                    <p style="text-indent: 10rem">
                                        ขอรับรองว่าโครงการดังกล่าวข้างต้นได้ผ่านการพิจารณารับรองจากคณะอนุกรรมการพิจารณาโครงการวิจัย กรมแพทย์ทหารบก
                                        ว่าสอดคล้องกับแนวทางจริยธรรมสากล ได้แก่ ปฏิญญาเฮลซิงกิรายงานเบลมองต์แนวทางจริยธรรมสากล
                                        สําหรับการวิจัยในมนุษย์ของสภาองค์การสากลด้านวิทยาศาสตร์การแพทย์ (CIOMS) และแนวทางการปฏิบัติการวิจัยที่ดี
                                        (ICH GCP)
                                    </p>
                                </v-flex>
                            </v-layout>

                            <!-- Form Date -->
                            <v-layout mt-12 style="padding-left: 80px; padding-right: 80px;">
                                <v-flex xs3 d-flex align-center class="text-start" style="font-weight: bold">
                                   <span>Date of Approval</span>
                                </v-flex>
                                <v-flex shrink mr-3 d-flex align-center class="text-end" style="font-weight: bold">
                                    <span>วันที่</span>
                                </v-flex>
                                <v-flex xs5 d-flex align-center class="text-start">
                                    <v-menu
                                            v-model="menu_date7"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    v-model="dateChange7"
                                                    readonly
                                                    hide-details
                                                    append-icon="date_range"
                                                    background-color="#FBF6F3"
                                                    item-color="#3E7662"
                                                    color="#3E7662"
                                                    filled
                                                    outlined
                                                    dense
                                                    v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                                @input="selectDate($event, 'menu_date7')"
                                                locale="th"
                                                type="date"
                                                color="#3E7662"
                                                header-color="#3E7662"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </v-layout>
                            <v-layout mt-12 style="padding-left: 80px; padding-right: 80px;">
                                <v-flex xs3 d-flex align-center class="text-start" style="font-weight: bold">
                                   <span>Date of Expiration</span>
                                </v-flex>
                                <v-flex shrink mr-3 d-flex align-center class="text-end" style="font-weight: bold">
                                    <span>วันที่</span>
                                </v-flex>
                                <v-flex xs5 d-flex align-center class="text-start">
                                    <v-menu
                                            v-model="menu_date8"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    v-model="dateChange8"
                                                    readonly
                                                    hide-details
                                                    append-icon="date_range"
                                                    background-color="#FBF6F3"
                                                    item-color="#3E7662"
                                                    color="#3E7662"
                                                    filled
                                                    outlined
                                                    dense
                                                    v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                                @input="selectDate($event, 'menu_date8')"
                                                locale="th"
                                                type="date"
                                                color="#3E7662"
                                                header-color="#3E7662"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </v-layout>

                            <!--frequency-->
                            <v-layout mt-12 style="padding-left: 80px; padding-right: 80px;">
                                <v-flex pt-4 shrink d-flex align-center class="text-start" style="font-weight: bold">
                                   <span>Frequency of progress report submission</span>
                                </v-flex>
                                <v-flex xs4 d-flex align-center class="text-start" style="padding-left: 15px;">
                                   <v-text-field
                                           v-model="form.thFrequency"
                                           color="#3E7662"
                                           hide-details
                                   />
                                </v-flex>
                                <v-flex pt-4 shrink style="font-weight: bold">
                                    <span>(6 months or 1 year)</span>
                                </v-flex>
                            </v-layout>

                            <!--signature-->
                            <v-layout style="padding-left: 80px; padding-right: 80px;margin-top: 100px">
                                <v-spacer></v-spacer>
                                <v-flex shrink pt-5 class="text-end">
                                   <span style="font-weight: bold;">พันเอก</span>
                                </v-flex>
                                <v-flex xs5 pl-2 d-flex align-center class="text-end">
                                   <v-text-field
                                           v-model="form.thSignature"
                                           color="#3E7662"
                                           append-icon="edit"
                                   />
                                </v-flex>
                            </v-layout>
                            <v-layout style="padding-left: 80px; padding-right: 80px;">
                                <v-spacer></v-spacer>
                                <v-flex xs5 style="font-weight: bold">
                                    <div>(สุธีพานิชกุล)</div>
                                    <div>ประธานคณะอนุกรรมการพิจารณาโครงการวิจัย</div>
                                    <div>กรมแพทย์ทหารบก</div>
                                </v-flex>
                            </v-layout>

                            <v-layout mt-12>
                                <v-flex class="text-start">
                                    <span>สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span>
                                </v-flex>
                            </v-layout>

                        </v-card>
                        <!--End Card 2 -->

                        <!-- Start Card 3 -->
                        <v-card class="mt-12" style="padding: 50px 70px 100px 70px">
                            <!-- Header -->
                            <v-layout>
                                <v-flex mr-4 shrink d-flex justify-start align-center>
                                    <img src="../../assets/LogoTh.png" width="124" alt="">
                                </v-flex>
                                <v-flex justify-start align-center>
                                    <!-- Text header -->
                                    <v-layout>
                                        <v-flex class="text-start">
                                            <span style="font-weight: bold;font-size: 18px;">คณะอนุกรรมการพิจารณาโครงการวิจัย กรมแพทย์ทหารบก</span>
                                        </v-flex>
                                    </v-layout>
                                    <!-- divider -->
                                    <v-layout mt-4>
                                        <v-flex>
                                            <v-divider style="background-color: #544A44;"></v-divider>
                                        </v-flex>
                                    </v-layout>
                                    <!-- Address -->
                                    <v-layout mt-2>
                                        <v-flex class="text-start">
                                            <span>ชั้น 5 อาคารพระมงกุฎเกล้าเวชวิทยา วิทยาลัยแพทยศาสตร์พระมงกุฎเกล้า</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex class="text-start">
                                            <span>317/5ถนน ราชวิถีเขตราชเทวีกรุงเทพฯ 10400 โทรศัพท์, (662) 763-4297, (662) 763-4270โทรสาร (662) 354-9011</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex class="text-start">
                                            <span>www.irbrta.pmk.ac.th, www.amed.go.th/rtamed/irbrta/ E-mail; irbrta@yahoo.com, irbrta@amed.go.th</span>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <!-- No. IRBRTA and Code -->
                            <v-layout style="margin-top: 80px">
                                <v-flex xs4 d-flex align-center>
                                    <!-- No. IRBRTA -->
                                    <v-layout>
                                        <v-flex shrink pt-5 style="font-weight: bold;">
                                            <span>ที่่ IRBRTA</span>
                                        </v-flex>
                                        <v-flex xs4 class="text-field-center">
                                            <v-text-field color="#3E7662" v-model="form.IRBTABefore" hide-details />
                                        </v-flex>
                                        <span class="pt-5" style="font-weight: bold;">/</span>
                                        <v-flex xs4 class="text-field-center">
                                            <v-text-field color="#3E7662" v-model="form.IRBTAAfter" hide-details />
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-spacer></v-spacer>
                                <v-flex xs4 d-flex align-center>
                                    <!-- Code -->
                                    <v-layout>
                                        <v-flex class="text-end" mr-4 pt-2 style="font-weight: bold;">
                                            <span>วัน/เดือน/ปี :</span>
                                        </v-flex>
                                        <v-flex>
                                            <v-menu
                                                    v-model="menuDatePage3"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                            v-model="dateChange"
                                                            readonly
                                                            item-color="#3E7662"
                                                            color="#3E7662"
                                                            dense
                                                            v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                        @input="selectDate($event, 'menuDatePage3')"
                                                        locale="th"
                                                        type="date"
                                                        color="#3E7662"
                                                        header-color="#3E7662"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <v-layout pl-12 style="margin-top: 80px">
                                <v-flex style="font-weight: bold;" class="text-start">
                                    <span>เรื่อง ขอชี้แจงการดําเนินการต่างๆ เกี่ยวกับโครงร่างการวิจัยที่ได้รับการรับรอง</span>
                                </v-flex>
                            </v-layout>
                            <v-layout pl-12 mt-4>
                                <v-flex shrink mr-4 d-flex align-center style="font-weight: bold;" class="text-start">
                                    <span>เรียน</span>
                                </v-flex>
                                <v-flex xs5 d-flex align-center style="font-weight: bold;" class="text-start">
                                    <textfield-form
                                            hide-detail
                                            :model="form.receiver"
                                            style="font-weight: bold"
                                            @update-data="updateData('receiver', $event)"
                                    ></textfield-form>
                                </v-flex>
                            </v-layout>

                            <!-- Detail -->
                            <v-layout pl-12 mt-12>
                                <v-flex pt-5 shrink mr-2 style="font-weight: bold;" class="text-start">
                                    <div style="text-indent: 10rem;" class="text-field-center text-field-margin">
                                        <span>ตามที่ท่านได้ส่งโครงร่างการวิจัยและเอกสารที่เกี่ยวข้อง เพื่อพิจารณาระเบียบวิธีวิจัยและจริยธรรม ฉบับที่</span>
                                        <v-text-field class="d-inline-block" style="width: 70px;margin-top: -10" color="#3E7662" hide-details v-model="form.version"/>
                                        <span>วันที่</span>
                                        <span>
                                            <v-menu
                                                v-model="menu_date4"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        hide-details
                                                        style="width: 7rem"
                                                        class="d-inline-block"
                                                        v-model="dateChange4"
                                                        readonly
                                                        item-color="#3E7662"
                                                        color="#3E7662"
                                                        dense
                                                        v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                    @input="selectDate($event, 'menu_date4')"
                                                    locale="th"
                                                    type="date"
                                                    color="#3E7662"
                                                    header-color="#3E7662"
                                            ></v-date-picker>
                                        </v-menu>
                                        </span>
                                        <span style="color: #CC3D45;">(รหัส EC)</span>
                                        <span> เรื่อง</span>
                                        <span><v-text-field class="d-inline-block" style="width: 25rem;" color="#3E7662" hide-details v-model="form.researchName"/></span>
                                        <span>นั้น คณะอนุกรรมการฯได้พิจารณารับรองโครงร่างการวิจัย เมื่อ</span>
                                        <span class="text-field-color">
                                            <v-menu
                                                    v-model="menu_date5"
                                                    :close-on-content-click="false"
                                                    :nudge-right="40"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="290px"
                                            >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                            hide-details
                                                            style="width: 7rem"
                                                            class="d-inline-block"
                                                            v-model="dateChange5"
                                                            readonly
                                                            color="#CC3D45"
                                                            dense
                                                            v-on="on"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                        @input="selectDate($event, 'menu_date5')"
                                                        locale="th"
                                                        type="date"
                                                        color="#3E7662"
                                                        header-color="#3E7662"
                                                ></v-date-picker>
                                            </v-menu>
                                        </span>
                                        <spa>ระยะเวลาการรับรอง1ปีนับตั้งแต่วันที่ได้รับการ รับรองโครงการวิจัย และความถี่ในการส่งรายงานความก้าวหน้าทุก</spa>
                                        <span><v-text-field class="d-inline-block mb-2" style="width: 70px;margin-top: -10" color="#3E7662" hide-details v-model="form.frequency"/></span>
                                        <span style="color: #CC3D45;">ปี/เดือน</span>
                                        <span class="pl-2" style="text-decoration: underline">ผู้วิจัยกรุณาส่งรายงานความก้าวหน้างานวิจัย ภายใน 1 เดือน ก่อนหมดอายุการรับรอง</span>
                                        <span> เพื่อพิจารณาการรับรองต่อเนื่องคณะอนุกรรมการฯขอชี้แจงเกี่ยวกับการส่งรายงาน ต่างๆ มายังคณะอนุกรรมการฯ ดังนี้</span>
                                    </div>
                                    <div style="margin-top: 50px;">
                                        (1) แบบรายงานส่วนแก้ไขเพิ่มเติมโครงร่างการวิจัย (Amendment) (RF 12_2562) เมื่อมีการแก้ไขเพิ่มเติมโครงร่างการวิจัย ผู้วิจัยต้องส่งโครงร่างการวิจัยที่มีการแก้ไขเพิ่มเติม เพื่อแจ้งให้คณะอนุกรรมการฯ
                                        พิจารณารับรองก่อนดําเนินการ ตามที่ได้แก้ไขเพิ่มเติม (ยกเว้นในกรณีที่การแก้ไขเพิ่มเติมนั้นกระทําเพื่อความปลอดภัยของอาสาสมัคร)
                                    </div>
                                    <div style="margin-top: 50px;">
                                        (2) รายงานความก้าวหน้าของการวิจัย (Progress report) (RF 03_2560) ผู้วิจัยต้องส่งรายงานความก้าวหน้าของการ วิจัยตามระยะเวลาที่คณะอนุกรรมการฯ กําหนดและอย่างน้อย 30 วัน
                                        ก่อนหมดอายุการรับรองในกรณีที่การวิจัย ยังไม่สิ้นสุด ผู้วิจัยต้องส่งจดหมายขอต่ออายุการรับรองโครงร่างการวิจัย
                                    </div>
                                    <div style="margin-top: 50px;">
                                        (3) รายงานเหตุการณ์ไม่พึงประสงค์ (RF 04_1_2560 หรือ RF 04_2_2560) เมื่อมีเหตุการณ์ไม่พึงประสงค์ชนิด ร้ายแรงให้รายงานตามข้อกําหนดของ ICH GCP
                                    </div>
                                    <div style="margin-top: 50px;">
                                        (4) รายงานไม่ปฏิบัติตามข้อกําหนด (RF 05_2560) เมื่อมีการเบี่ยงเบนหรือไม่ปฏิบัติตามโครงร่างการวิจัยที่ได้รับการรับรอง
                                    </div>
                                    <div style="margin-top: 50px;">
                                        (5) รายงานสรุปผลการวิจัย (Final report) (RF 06_2560)และบทคัดย่อภาษาไทยและ/หรือภาษาอังกฤษเมื่อการวิจัยสิ้นสุดแล้ว
                                    </div>
                                    <div style="margin-top: 60px;">
                                        <span>หมายเหตุ : สามารถ Download แบบรายงานต่างๆ </span>
                                        <span style="font-weight: bold;">ได้ที่ </span>
                                        <span style="color: #3E7662;font-weight: bold">http://www.irbrta.pmk.ac.th</span>
                                    </div>

                                </v-flex>
                            </v-layout>

                            <v-layout pl-12 style="margin-top: 100px;">
                                <v-flex class="text-start" style="font-size: 20px;font-weight: bold;">
                                    <span>จึงเรียนมาเพื่อทราบ</span>
                                </v-flex>
                            </v-layout>

                            <v-layout mt-6 style="padding-left: 80px; padding-right: 80px;">
                                <v-spacer></v-spacer>
                                <v-flex xs5 style="font-weight: bold;font-size: 20px;">
                                    <div>ขอแสดงความนับถือ</div>
                                </v-flex>
                            </v-layout>
                            <v-layout style="padding-left: 80px; padding-right: 80px;margin-top: 50px">
                                <v-spacer></v-spacer>
                                <v-flex shrink pt-5 class="text-end">
                                    <span style="font-weight: bold;">พันเอก</span>
                                </v-flex>
                                <v-flex xs5 pl-2 d-flex align-center class="text-end text-field-center" style="font-weight: bold">
                                    <v-text-field
                                            v-model="form.signature"
                                            color="#3E7662"
                                            append-icon="edit"
                                    />
                                </v-flex>
                            </v-layout>
                            <v-layout style="padding-left: 80px; padding-right: 80px;">
                                <v-spacer></v-spacer>
                                <v-flex xs5 style="font-weight: bold">
                                    <div>(สุธีพานิชกุล)</div>
                                    <div>ประธานคณะอนุกรรมการพิจารณาโครงการวิจัย</div>
                                    <div>กรมแพทย์ทหารบก</div>
                                </v-flex>
                            </v-layout>

                            <v-layout mt-12>
                                <v-flex class="text-start">
                                    <span>สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span>
                                </v-flex>
                            </v-layout>


                        </v-card>
                        <!--End Card 3 -->

                    <!-- End Form -->

                        <!-- Button Save -->
                        <v-layout mt-8>
                            <v-flex mb-12 style="text-align: right;">
                                <v-layout>
                                    <v-flex>
                                        <v-btn style="color: #3E7662" class="mx-4" depressed  color="#ffffff" @click.native="$router.go(-1)">ย้อนกลับ</v-btn>
                                        <v-btn depressed  dark color="#3E7662" @click="save">
<!--                                            <v-icon class="mr-3">add</v-icon>-->
                                            <span>บันทึกข้อมูล</span>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <loading
                        color="#527281"
                        :active.sync="isLoading"
                        :can-cancel="false"
                        :is-full-pageAndLine="fullpageAndLine"
                ></loading>
            </v-flex>
        </v-layout>
    </v-content>
</template>

<script>
    import TextfieldForm from "../../components/input/TextfieldForm";
    import DateInputForm from "../../components/input/DateInputForm";
    import TextareaForm from "../../components/input/TextareaForm";
    import Swal from 'sweetalert2';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import TextfieldFormAppend from "../../components/input/TextfieldFormAppend";
    import { mapState } from "vuex";

    export default {
        name: "FormRL01",
        components: {
            TextfieldForm,
            DateInputForm,
            TextareaForm,
            Loading,
            TextfieldFormAppend,
        },
        data: () => ({
            isLoading: false,
            fullpageAndLine: true,
            menu_date0: false,
            menu_date1: false,
            menu_date2: false,
            menu_date3: false,
            menu_date4: false,
            menu_date5: false,
            menu_date6: false,
            menu_date7: false,
            menu_date8: false,
            menuDatePage3: false,
            disabled: false,
            form: {
                researchID: '',
                enIRBTABefore: '',
                enIRBTAAfter: '',
                enCode: '',
                enTitle: '',
                enProtocol: '',
                enPrincipal: '',
                enDepartment: '',
                enStudySite: '',
                researchProtocol: '',
                informedConsent: '',
                other: '',
                investigator: '',
                enApprovalDate: '',
                enExpireDate: '',
                enFrequency: '',
                enSignature: '',
                thIRBTABefore: '',
                thIRBTAAfter: '',
                thCode: '',
                thTitle: '',
                thProtocol: '',
                thPrincipal: '',
                thDepartment: '',
                thStudySite: '',
                approveDoc1: '',
                approveDoc1Version: '',
                approveDoc1Date: '',
                approveDoc2: '',
                approveDoc2Version: '',
                approveDoc2Date: '',
                approveDoc3: '',
                approveDoc3Version: '',
                approveDoc3Date: '',
                thApprovalDate: '',
                thExpireDate: '',
                thFrequency: '',
                thSignature: '',
                IRBTABefore: '',
                IRBTAAfter: '',
                formDate: '',
                receiver: '',
                version: '',
                date: '',
                researchName: '',
                sendDate: '',
                frequency: '',
                signature: '',
            },
            dateChange0: '',
            dateChange1: '',
            dateChange2: '',
            dateChange3: '',
            dateChange4: '',
            dateChange5: '',
            dateChange6: '',
            dateChange7: '',
            dateChange8: '',
            dateChange: '',
        }),
        computed: {
            ...mapState({
                user: state => state.Auth.user
            })
        },
        created() {
            // Check Permission Access
            // if (this.user.currentRole !== 4) {
            //     this.$router.go(-1);
            // }
            this.getRL01();
        },
        methods:{
            updateData(name, val) {
                this.form[name] = val;
            },
            save() {
                Swal.fire({
                    title: 'คุณต้องการบันทึกหรือไม่?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3E7662',
                    cancelButtonColor: 'rgb(189, 189, 189)',
                    confirmButtonText: 'ใช่ บันทึก',
                }).then((result) => {
                    if (result.value) {
                        this.isLoading = true;
                        this.form['researchID'] = this.$route.query.id;
                        this.$store.dispatch("FormRL/saveRL01", this.form).then(res => {
                            Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: 'บันทึกสำเร็จ',
                                showConfirmButton: false,
                                timer: 1500
                            })
                            this.isLoading = false;
                        }).catch(e => {
                            this.isLoading = false;
                            if (e.response.data.errors) {
                                for (var k in e.response.data.errors) {
                                Swal.fire({
                                    title: "เกิดข้อผิดพลาด",
                                    text: e.response.data.errors[k][0],
                                    icon: "warning",
                                    confirmButtonColor: "#3E7662",
                                }).then(() => {
                                    this.$vuetify.goTo(`#${k}`);
                                });
                                }
                            }
                            // Swal.fire({
                            //     title: 'Save failed!',
                            //     text: 'บันทึกไม่สำเร็จ',
                            //     icon: 'warning',
                            // })
                            // this.isLoading = false;
                        })
                    }
                });
            },
            getRL01() {
                this.isLoading = true;
                this.$store.dispatch("FormRL/getRL01", this.$route.query.id).then(res => {
                    this.form.researchID = res.researchID;
                    this.form.enIRBTABefore = res.enIRBTABefore;
                    this.form.enIRBTAAfter = res.enIRBTAAfter;
                    this.form.enCode = res.enCode;
                    this.form.enTitle = res.enTitle;
                    this.form.enProtocol = res.enProtocol;
                    this.form.enPrincipal = res.enPrincipal;
                    this.form.enDepartment = res.enDepartment;
                    this.form.enStudySite = res.enStudySite;
                    this.form.researchProtocol = res.researchProtocol;
                    this.form.informedConsent = res.informedConsent;
                    this.form.other = res.other;
                    this.form.investigator = res.investigator;
                    this.selectDate(res.enApprovalDate,'menu_date0');
                    this.form.enApprovalDate = res.enApprovalDate;
                    this.selectDate(res.enExpireDate,'menu_date6');
                    this.form.enExpireDate = res.enExpireDate;
                    this.form.enFrequency = res.enFrequency;
                    this.form.enSignature = res.enSignature;
                    this.form.thIRBTABefore = res.thIRBTABefore;
                    this.form.thIRBTAAfter = res.thIRBTAAfter;
                    this.form.thCode = res.thCode;
                    this.form.thTitle = res.thTitle;
                    this.form.thProtocol = res.thProtocol;
                    this.form.thPrincipal = res.thPrincipal;
                    this.form.thDepartment = res.thDepartment;
                    this.form.thStudySite = res.thStudySite;
                    this.form.approveDoc1 = res.approveDoc1;
                    this.form.approveDoc1Version = res.approveDoc1Version;
                    this.selectDate(res.approveDoc1Date,'menu_date1');
                    this.form.approveDoc1Date = res.approveDoc1Date;
                    this.form.approveDoc2 = res.approveDoc2;
                    this.form.approveDoc2Version = res.approveDoc2Version;
                    this.selectDate(res.approveDoc2Date,'menu_date2');
                    this.form.approveDoc2Date = res.approveDoc2Date;
                    this.form.approveDoc3 = res.approveDoc3;
                    this.form.approveDoc3Version = res.approveDoc3Version;
                    this.selectDate(res.approveDoc3Date,'menu_date3');
                    this.form.approveDoc3Date = res.approveDoc3Date;
                    this.selectDate(res.thApprovalDate,'menu_date7');
                    this.form.thApprovalDate = res.thApprovalDate;
                    this.selectDate(res.thExpireDate,'menu_date8');
                    this.form.thExpireDate = res.thExpireDate;
                    this.form.thFrequency = res.thFrequency;
                    this.form.thSignature = res.thSignature;
                    this.form.IRBTABefore = res.IRBTABefore;
                    this.form.IRBTAAfter = res.IRBTAAfter;
                    this.selectDate(res.formDate,'menuDatePage3');
                    this.form.formDate = res.formDate;
                    this.form.receiver = res.receiver;
                    this.form.version = res.version;
                    this.selectDate(res.date,'menu_date4');
                    this.form.date = res.date;
                    this.form.researchName = res.researchName;
                    this.selectDate(res.sendDate,'menu_date5');
                    this.form.sendDate = res.sendDate;
                    this.form.frequency = res.frequency;
                    this.form.signature = res.signature;
                    this.isLoading = false;
                }).catch(e => {
                    this.isLoading = false;
                })
            },
            selectDate(val,name) {
                if (name === 'menu_date0') {
                    this.menu_date0 = false;
                    // call function changeDate
                    let changeDate = this.changeDate(val);
                    this.dateChange0 = changeDate;
                    this.form.enApprovalDate = val;
                }
                if (name === 'menu_date1') {
                    this.menu_date1 = false;
                    // call function changeDate
                    let changeDate = this.changeDate(val);
                    this.dateChange1 = changeDate;
                    this.form.approveDoc1Date = val;
                }
                if (name === 'menu_date2') {
                    this.menu_date2 = false;
                    // call function changeDate
                    let changeDate = this.changeDate(val);
                    this.dateChange2 = changeDate;
                    this.form.approveDoc2Date = val;
                }
                if (name === 'menu_date3') {
                    this.menu_date3 = false;
                    // call function changeDate
                    let changeDate = this.changeDate(val);
                    this.dateChange3 = changeDate;
                    this.form.approveDoc3Date = val;
                }
                if (name === 'menu_date4') {
                    this.menu_date4 = false;
                    // call function changeDate
                    let changeDate = this.changeDate(val);
                    this.dateChange4 = changeDate;
                    this.form.date = val;
                }
                if (name === 'menu_date5') {
                    this.menu_date5 = false;
                    // call function changeDate
                    let changeDate = this.changeDate(val);
                    this.dateChange5 = changeDate;
                    this.form.sendDate = val;
                }
                if (name === 'menu_date6') {
                    this.menu_date6 = false;
                    // call function changeDate
                    let changeDate = this.changeDate(val);
                    this.dateChange6 = changeDate;
                    this.form.enExpireDate = val;
                }
                if (name === 'menu_date7') {
                    this.menu_date7 = false;
                    // call function changeDate
                    let changeDate = this.changeDate(val);
                    this.dateChange7 = changeDate;
                    this.form.thApprovalDate = val;
                }
                if (name === 'menu_date8') {
                    this.menu_date8 = false;
                    // call function changeDate
                    let changeDate = this.changeDate(val);
                    this.dateChange8 = changeDate;
                    this.form.thExpireDate = val;
                }
                if (name === 'menuDatePage3') {
                    this.menuDatePage3 = false
                    // call function changeDate
                    let changeDate = this.changeDate(val);
                    this.dateChange = changeDate;
                    this.form.formDate = val;
                }
            },
            // Change Date
            changeDate(val) {
                //change date start
                let sub_year = val.substring(0,4);
                let sub_month = val.substring(5,7);
                let sub_day = val.substring(8,10);

                sub_year = parseInt(sub_year)+543;

                let changeDate = sub_day + '/' + sub_month + '/' + sub_year;
                return changeDate;
            },

            setData() {
                this.form.researchID ='Test';
                this.form.enIRBTABefore ='Test';
                this.form.enIRBTAAfter ='Test';
                this.form.enCode ='Test';
                this.form.enTitle = 'Test';
                this.form.enProtocol = 'Test';
                this.form.enPrincipal = 'Test';
                this.form.enDepartment = 'Test';
                this.form.enStudySite = 'Test';
                this.form.researchProtocol = 'Test';
                this.form.informedConsent = 'Test';
                this.form.other = 'Test';
                this.form.investigator = 'Test';
                this.form.enApprovalDate = '2020-02-12';
                this.form.enExpireDate = '2020-02-12';
                this.form.enFrequency = 'Test';
                this.form.enSignature = 'Test';
                this.form.thIRBTABefore = 'Test';
                this.form.thIRBTAAfter = 'Test';
                this.form.thCode = 'Test';
                this.form.thTitle = 'Test';
                this.form.thProtocol = 'Test';
                this.form.thPrincipal = 'Test';
                this.form.thDepartment = 'Test';
                this.form.thStudySite = 'Test';
                this.form.approveDoc1 = 'Test';
                this.form.approveDoc1Version = 'Test';
                this.form.approveDoc1Date = '2020-02-12';
                this.form.approveDoc2 = 'Test';
                this.form.approveDoc2Version = 'Test';
                this.form.approveDoc2Date = '2020-02-12';
                this.form.approveDoc3 = 'Test';
                this.form.approveDoc3Version = 'Test';
                this.form.approveDoc3Date = '2020-02-12';
                this.form.thApprovalDate = '2020-02-12';
                this.form.thExpireDate = '2020-02-12';
                this.form.thFrequency = 'Test';
                this.form.thSignature = 'Test';
                this.form.IRBTABefore = 'Test';
                this.form.IRBTAAfter = 'Test';
                this.form.formDate = '2020-02-12';
                this.form.receiver = 'Test';
                this.form.version = 'Test';
                this.form.date = '2020-02-12';
                this.form.researchName = 'Test';
                this.form.sendDate = '2020-02-12';
                this.form.frequency = 'Test';
                this.form.signature = 'Test';
            },
        },
    }
</script>

<style lang="scss">
    /*** Table Styles **/
    .table-style {
        .table-fill {
            background: white;
            border-radius:3px;
            border-collapse: collapse;
            margin: auto;
            padding:5px;
            width: 100%;
            box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
            animation: float 5s infinite;
            border-bottom: 5px solid #544A44;
        }

        th {
            color:#D5DDE5;;
            background:#3E7662;
            border-top:5px solid #544A44;
            border-right: 1px solid #544A44;
            font-weight: 700;
            padding:15px;
            vertical-align:middle;
        }

        /*th:first-child {*/
        /*    border-top-left-radius:3px;*/
        /*}*/

        th:last-child {
            border-top-right-radius:3px;
            border-right:none;
        }

        tr {
            border-top: 1px solid #544A44;
            border-bottom-: 1px solid #544A44;
            color:#ffffff;
        }

        /*tr:hover td {*/
        /*    background:#4E5066;*/
        /*    color:#FFFFFF;*/
        /*    border-top: 1px solid #22262e;*/
        /*}*/

        tr:first-child {
            border-top:none;
        }

        tr:last-child {
            /*border-bottom:5px solid #544A44;*/
        }

        /*tr:nth-child(odd) td {*/
        /*    background:#EBEBEB;*/
        /*}*/

        /*tr:nth-child(odd):hover td {*/
        /*    background:#4E5066;*/
        /*}*/

        tr:last-child td:first-child {
            border-bottom-left-radius:3px;
        }

        tr:last-child td:last-child {
            border-bottom-right-radius:3px;
        }

        td {
            background:#FFFFFF;
            padding:10px 30px 10px 30px;
            text-align:left;
            vertical-align:middle;
            font-weight:700;
            color: black;
            border-right: 1px solid #544A44;
        }

        td:last-child {
            border-right: 0px;
        }

        th.text-left {
            text-align: left;
        }

        th.text-center {
            text-align: center;
        }

        th.text-right {
            text-align: right;
        }

        td.text-left {
            text-align: left;
        }

        td.text-center {
            text-align: center;
        }

        td.text-right {
            text-align: right;
        }
    }
    .text-field-color {
         .theme--light.v-input, .theme--light.v-input input, .theme--light.v-input textarea {
             color: #CC3D45;
         }
    }
    .text-field-margin {
        .v-text-field {
            padding: 0;
            margin: 0;
        }
    }


</style>
